<template>
    <div class="treeview-node" :id="`${value.id}_${value.type}`">

        <alert-modal
            :drag-modal="dragModal"
            @cancelTreeModal="cancelTreeModal"
            @confirmTreeModal="confirmTreeModal"
            :source-item="sourceItem"
            :destination-item="destinationItem"
            :text="`Are you sure you want to drop '${sourceItem.type}' - ${sourceItem.name} into '${destinationItem.type}' - ${destinationItem.name}?`"
        ></alert-modal>

        <div @click="expand" :id="`${value.id}_${value.type}`">
            <tree-view-item :expanded="value.isExpanded" :value="value" @handleReassignItem="handleReassignItem"></tree-view-item>
        </div>
        <draggable v-model="value.items" :group="{ name: 'people'}" :id="`${value.id}_${value.type}`" :move="checkMove" @start="startMethod" @end="endMethod" @change="handleChange($event, value.items, treeName)" class="treeview-wrapper">
            <div
                 v-for="item in value.items"
                 :key="item.id"
                 v-show="value.isExpanded"
                 :id="`${item.id}_${item.type}`"
                 :class="[{
                     'organization': item.type === 'Organization',
                     'fleet': item.type === 'Fleet',
                     'vehicle': item.type === 'Vehicle',
                     'device': item.type === 'Device',
                 }]"
            >
                <treeview-node :key="item.id" :value="item" :ref="`treeview-node-${item.id}`" :id="`${item.id}_${item.type}`" :tree-name="treeName" :level="level + 1" @handleReassignItem="handleReassignItem" :update-counters="updateCounters"></treeview-node>
            </div>
        </draggable>
        <sp-loader v-if="isLoading"></sp-loader>

    </div>

</template>

<script>
import Draggable from 'vuedraggable'
import TreeViewItem from '@/views/Tree/TreeViewItem'
import SpLoader from '@/components/atoms/Loader'
import TreeVehiclesApi from '@/api/TreeVehiclesApi'
import DeviceApi from '@/api/DeviceApi'
import { CollectionTransformer } from '@/transformers'
import OrganizationVehicleTreeTransformer from '@/transformers/OrganizationVehicleTreeTransformer'
import _ from 'lodash-es'
import { mapGetters } from 'vuex'
import OrganizationTreeService from '@/services/OrganizationTreeService'
import AlertModal from '@/views/Tree/components/AlertModal'
import TreeApi from '../../api/TreeApi'
import OrganizationTreeTransformer from '@/transformers/OrganizationTreeTransformer'

const treeVehicleApi = new TreeVehiclesApi()
const collectionTransformer = new CollectionTransformer()
const organizationVehicleTransformer = new OrganizationVehicleTreeTransformer()
const deviceApi = new DeviceApi()
const treeApi = new TreeApi()
const organizationTreeTransformer = new OrganizationTreeTransformer()

export default {
    name: 'TreeviewNode',
    components: {
        Draggable,
        TreeViewItem,
        SpLoader,
        AlertModal
    },
    data () {
        return {
            isTreeChanged: false,
            isLoading: false,
            isFetched: false,
            dragModal: false,
            modalAccept: false,
            dataConfirmTreeModal: {
                event: null
            }
        }
    },
    props: {
        value: {
            type: [Object, Array]
        },
        treeName: {
            type: String,
            required: true
        },
        level: {
            type: Number,
            required: true
        },
        updateCounters: {
            type: Function,
            required: true
        }
    },
    computed: {
        ...mapGetters({
            organizationTreeItems: 'organizationTreeModule/organizationTreeItems',
            organizationTreePlaceholder: 'organizationTreeModule/organizationTreePlaceholder',
            latestFullTree: 'organizationTreeModule/latestFullTree',
            isSearchActive: 'organizationTreeModule/isSearchActive'
        }),
        sourceItem: {
            get () {
                return this.$store.getters['organizationTreeModule/sourceItem']
            },
            set (value) {
                this.$store.commit('organizationTreeModule/setSourceItem', value)
            }
        },
        destinationItem: {
            get () {
                return this.$store.getters['organizationTreeModule/destinationItem']
            },
            set (value) {
                this.$store.commit('organizationTreeModule/setDestinationItem', value)
            }
        },
        sourceItemIdAndType: {
            get () {
                return this.$store.getters['organizationTreeModule/sourceItemIdAndType']
            },
            set (value) {
                this.$store.commit('organizationTreeModule/setSourceItemIdAndType', value)
            }
        },
        destinationItemIdAndType: {
            get () {
                return this.$store.getters['organizationTreeModule/destinationItemIdAndType']
            },
            set (value) {
                this.$store.commit('organizationTreeModule/setDestinationItemIdAndType', value)
            }
        },
        prevOrganizationTreeItems: {
            get () {
                return this.$store.getters['organizationTreeModule/prevOrganizationTreeItems']
            },
            set (value) {
                this.$store.commit('organizationTreeModule/setPrevOrganizationTreeItems', value)
            }
        },
        prevOrganizationTreePlaceholder: {
            get () {
                return this.$store.getters['organizationTreeModule/prevOrganizationTreePlaceholder']
            },
            set (value) {
                this.$store.commit('organizationTreeModule/setPrevOrganizationTreePlaceholder', value)
            }
        },
        latestFullTree: {
            get () {
                return this.$store.getters['organizationTreeModule/latestFullTree']
            },
            set (value) {
                this.$store.commit('organizationTreeModule/setLatestFullTree', value)
            }
        }
    },
    mounted () {
        if ('1e15dd2b-1c5e-45b3-b8a6-880f73abebdc' === this.value.id) {
            this.value.isExpanded = true
        }
    },
    methods: {
        getTreeVehicles: async function () {
            const response = await treeVehicleApi.getTreeVehicles({
                fleetId: this.value.id
            })

            let vehicles = []
            response.payload.forEach((vehicleItem) => {
                let vehicleTransformed = organizationVehicleTransformer.transform(vehicleItem)
                vehicleTransformed.setParent(this.value)
                vehicles.push(vehicleTransformed)
            })

            this.value.addVehicles(vehicles)
            this.value.isFetched = true
        },
        expand () {
            this.value.isExpanded = !this.value.isExpanded
            if ('Fleet' === this.value.type && !this.value.isFetched && false === this.isSearchActive) {
                this.getTreeVehicles()
            }

            if (this.value.isExpanded && 0 === this.value.items.length) {
                this.isLoading = true
                this.loadData()
                this.isLoading = false
            }
        },
        loadData () {
            const type = this.value.type

            switch (type) {
                case 'Organization': return this.value.items
                case 'Fleet': return this.value.items
                case 'Vehicle': return this.value.items
                case 'Device': return null
            }
        },
        checkMove (evt) {
            const isVehicleEmpty = evt.to.children.length

            // zagniezdzenie organizacja
            if (this.isAllowedToDragInTree(evt, 'Organization', 'Organization')) {
                return true
            }
            if (this.isAllowedToDragFromPlaceholder(evt, 'Organization', 'Organization')) {
                return true
            }

            // zagniezdzenie flota
            if (this.isAllowedToDragInTree(evt, 'Fleet', 'Organization')) {
                return true
            }
            if (this.isAllowedToDragFromPlaceholder(evt, 'Fleet', 'Organization')) {
                return true
            }

            // ruch vehicla z placeholdera do lewego drzewka
            if (this.isAllowedToDragInTree(evt, 'Vehicle', 'Fleet')) {
                return true
            }
            if (this.isAllowedToDragFromPlaceholder(evt, 'Vehicle', 'Fleet')) {
                return true
            }

            // ruch device z placeholdera do lewego drzewka
            if ((this.isAllowedToDragInTree(evt, 'Device', 'Vehicle')) ||
                (this.isAllowedToDragInTree(evt, 'Device', 'Fleet')) ||
                (this.isAllowedToDragInTree(evt, 'Device', 'Organization'))) {
                return true
            }
            if ((this.isAllowedToDragFromPlaceholder(evt, 'Device', 'Vehicle')) ||
                (this.isAllowedToDragFromPlaceholder(evt, 'Device', 'Fleet')) ||
                (this.isAllowedToDragFromPlaceholder(evt, 'Device', 'Organization'))) {
                return true
            }

            // inne opcje
            if (this.fromPlaceholderToPlaceholder(evt)) {
                return false
            }
            if (this.fromTreeToPlaceholder(evt)) {
                return true
            }

            return false
        },
        isAllowedToDragInTree (evt, draggedFrom, draggedTo) {
            const draggedItem = evt.dragged.id
            const draggedItemType = draggedItem.split('_')
            const dropTarget = evt.to.id
            const dropType = dropTarget.split('_')
            const dragFromTree = evt.from.closest('.left')
            const dragToTree = evt.to.closest('.left')

            return (dragFromTree && dragToTree && draggedFrom === draggedItemType[1] && draggedTo === dropType[1])
        },
        isAllowedToDragFromPlaceholder (evt, draggedFrom, draggedTo) {
            const draggedItem = evt.dragged.id
            const draggedItemType = draggedItem.split('_')
            const dropTarget = evt.to.id
            const dropType = dropTarget.split('_')
            const dragFromTree = evt.from.closest('.right')
            const dragToTree = evt.to.closest('.left')

            return (dragFromTree && dragToTree && draggedFrom === draggedItemType[1] && draggedTo === dropType[1])
        },
        fromPlaceholderToPlaceholder (evt) {
            const dragFromPlaceholder = evt.from.closest('.right')
            const dragToPlaceholder = evt.to.closest('.right')

            return (dragFromPlaceholder && dragToPlaceholder)
        },
        fromTreeToPlaceholder (evt) {
            const itemFromTree = evt.from.className
            const itemToPlaceholder = evt.to.className

            return ('treeview-wrapper' === itemFromTree && 'draggable-right' === itemToPlaceholder)
        },
        startMethod (elem) {
        },
        endMethod (elem) {
            const isElementDraggedFrom = elem.from
            const isElementDraggedTo = elem.to

            this.fromItemIdAndType = elem.from.id
            this.sourceItemIdAndType = elem.item.id
            this.destinationItemIdAndType = elem.to.id

            let destinationItemId
            const sourceItemId = this.sourceItemIdAndType.split('_')[0]

            if (elem.to.closest('.left') && elem.from.closest('.left')) {
                // original -> original
                destinationItemId = this.destinationItemIdAndType.split('_')[0]
                const destinationItem = this.getNode(this.organizationTreeItems[0], destinationItemId)
                const sourceItem = this.getNode(this.organizationTreeItems[0], sourceItemId)
                const fromItemId = this.fromItemIdAndType.split('_')[0]
                const fromItem = this.getNode(this.organizationTreeItems[0], fromItemId)

                sourceItem.parent = destinationItem

                this.updateCounters(destinationItem, sourceItem, 'add')
                this.updateCounters(fromItem, sourceItem, 'subtract')
                this.sourceItem = sourceItem
                this.destinationItem = destinationItem
            } else if (elem.to.closest('.left') && !elem.from.closest('.left')) {
                // placeholder -> original
                destinationItemId = this.destinationItemIdAndType.split('_')[0]
                const sourceItem = this.getNode(this.organizationTreeItems[0], sourceItemId)
                const destinationItem = this.getNode(this.organizationTreeItems[0], destinationItemId)

                const fromItemId = this.fromItemIdAndType.split('_')[0]

                let fromItem = null
                if (fromItemId) {
                    this.organizationTreePlaceholder.forEach(orgTree => {
                        const item = this.getNode(orgTree, fromItemId)
                        if (item) fromItem = item
                    })
                }

                sourceItem.parent = destinationItem

                this.updateCounters(destinationItem, sourceItem, 'add')
                this.updateCounters(fromItem, sourceItem, 'subtract')
                this.sourceItem = sourceItem
                this.destinationItem = destinationItem
            } else if (!elem.to.closest('.left') && elem.from.closest('.left')) {
                // original -> placeholder
                let sourceItem
                this.organizationTreePlaceholder.forEach(orgTree => {
                    const item = this.getNode(orgTree, sourceItemId)
                    if (item) sourceItem = item
                })
                destinationItemId = this.destinationItemIdAndType.split('_')[0]
                let destinationItem = null
                if (destinationItemId) {
                    this.organizationTreePlaceholder.forEach(orgTree => {
                        const item = this.getNode(orgTree, destinationItemId)
                        if (item) destinationItem = item
                    })
                }

                const fromItemId = this.fromItemIdAndType.split('_')[0]
                const fromItem = this.getNode(this.organizationTreeItems[0], fromItemId)

                sourceItem.parent = destinationItem

                this.updateCounters(destinationItem, sourceItem, 'add')
                this.updateCounters(fromItem, sourceItem, 'subtract')

                if (true === this.isSearchActive) {
                    sourceItem.items = []
                    const nodeWithAllItems = this.getNode(this.latestFullTree[0], sourceItemId)
                    sourceItem.items = _.cloneDeep((nodeWithAllItems.items))
                }
                this.$store.commit('organizationTreeModule/setPrevOrganizationTreePlaceholder', _.cloneDeep(this.organizationTreePlaceholder))
                this.$store.commit('organizationTreeModule/setPrevOrganizationTreeItems', _.cloneDeep(this.organizationTreeItems))
            } else if (!elem.to.closest('.left') && !elem.from.closest('.left')) {
                // placeholder -> placeholder
                let sourceItem
                this.organizationTreePlaceholder.forEach(orgTree => {
                    const item = this.getNode(orgTree, sourceItemId)
                    if (item) sourceItem = item
                })
                destinationItemId = this.destinationItemIdAndType.split('_')[0]
                let destinationItem = null
                if (destinationItemId) {
                    this.organizationTreePlaceholder.forEach(orgTree => {
                        const item = this.getNode(orgTree, destinationItemId)
                        if (item) destinationItem = item
                    })
                }

                const fromItemId = this.fromItemIdAndType.split('_')[0]
                let fromItem = null
                if (fromItemId) {
                    this.organizationTreePlaceholder.forEach(orgTree => {
                        const item = this.getNode(orgTree, fromItemId)
                        if (item) fromItem = item
                    })
                }

                sourceItem.parent = destinationItem

                this.updateCounters(destinationItem, sourceItem, 'add')
                this.updateCounters(fromItem, sourceItem, 'subtract')
            }

            if (null === elem.to.closest('.left')) {
                if (process.env.VUE_APP_DEBUG) {
                    console.debug('endMethod', 'tree updated')
                }
                this.prevOrganizationTreeItems = _.cloneDeep(this.organizationTreeItems)
                if (process.env.VUE_APP_DEBUG) {
                    console.debug('endMethod', 'placeholder tree updated')
                }
                this.prevOrganizationTreePlaceholder = _.cloneDeep(this.organizationTreePlaceholder)
            }

            if (isElementDraggedTo !== isElementDraggedFrom) {
                this.isTreeChanged = true
            }
            return false
        },
        cancelTreeModal () {
            this.dragModal = false

            this.dataConfirmTreeModal.event = null

            this.$store.commit('organizationTreeModule/setOrganizationTreeItems', _.cloneDeep(this.prevOrganizationTreeItems))
            this.$store.commit('organizationTreeModule/setOrganizationTreePlaceholder', _.cloneDeep(this.prevOrganizationTreePlaceholder))
        },
        async confirmTreeModal () {
            this.dragModal = false

            const parentId = this.destinationItemIdAndType.split('_')[0]

            const source = (this.dataConfirmTreeModal.event.moved || this.dataConfirmTreeModal.event.added).element
            const parent = this.getNode(this.organizationTreeItems[0], parentId)

            if (null == source || null == parent) {
                return
            }

            this.isLoading = true
            await OrganizationTreeService.moveItem(source.type, source.id, parent.type, parent.id)
            await this.moveChildItems(source, source.items)

            // reload tree
            const response = await treeApi.getTree()
            this.treeData = response
            this.totalResults = response.payload.totalResults

            const treeObject = organizationTreeTransformer.transform(response.payload)

            this.$store.commit('organizationTreeModule/setAsideBarHasChanged', true)
            this.$store.commit('organizationTreeModule/setLatestFullTree', [treeObject])
            this.isLoading = false

            this.$store.commit('organizationTreeModule/setPrevOrganizationTreePlaceholder', _.cloneDeep(this.organizationTreePlaceholder))
            this.$store.commit('organizationTreeModule/setPrevOrganizationTreeItems', _.cloneDeep(this.organizationTreeItems))

            return true
        },
        async moveChildItems (parent, items) {
            for (const item of items) {
                if (item.isChanged) {
                    await OrganizationTreeService.moveItem(item.type, item.id, parent.type, parent.id)
                }

                if (0 < item.items.length) {
                    await this.moveChildItems(item, item.items)
                }
            }
        },
        handleChange (event, list, name) {
            if (event.removed) {
                event.removed.element.isChanged = true
                return
            }

            if ((event.added || event.moved) && 'items' === this.treeName) {
                this.dataConfirmTreeModal.event = event
                this.dragModal = !this.dragModal
            }
        },
        handleReassignItem (itemToReassignData) {
            this.$emit('handleReassignItem', itemToReassignData)
        },
        getParentId (array, id, parentId) {
            return array.some(o => o.id === id || o.items && null !== (parentId = this.getParentId(o.items, id, o.id))) ? parentId : null
        },
        getNode (node, id) {
            if (node.id === id) {
                return node
            }

            for (const node of node.items) {
                const value = this.getNode(node, id)
                if (value) return value
            }
        }
    }
}
</script>

<style scoped lang="scss">
.treeview-node {
    padding-left: 8px;

    @media (min-width: 1200px) {
        padding-left: 20px;
    }
}

.sortable-ghost {
    width: 100%;
    padding-top: 10px;
    border-top: 2px solid $primary-default;
}

</style>
